import { render, staticRenderFns } from "./wgt-item.vue?vue&type=template&id=c127a286&scoped=true"
import script from "./wgt-item.vue?vue&type=script&lang=js"
export * from "./wgt-item.vue?vue&type=script&lang=js"
import style0 from "./wgt-item.vue?vue&type=style&index=0&id=c127a286&prod&lang=scss&scoped=true"
import style1 from "./wgt-item.vue?vue&type=style&index=1&id=c127a286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c127a286",
  null
  
)

export default component.exports